import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import './main-categories-item-updated.js';
import css_248z from './main-categories-updated.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
const jsonConverter = {
    fromAttribute: (v) => {
        try {
            return v ? JSON.parse(v) : undefined;
        }
        catch (_a) {
            console.warn('[MainCategoriesUpdated] JSON parse error:', v);
            return undefined;
        }
    },
    toAttribute: () => null,
};
const booleanConverter = {
    fromAttribute: (value) => value !== null,
    toAttribute: (value) => (value ? 'true' : null),
};
class MainCategoriesUpdated extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.categoryItems = [];
        this.title = 'Main categories';
        this.showTitle = false;
        this.centerTitle = false;
        this.isDesktop = false;
        this.query = '(max-width: 1365px)';
        this.componentId = `main-categories-${crypto.randomUUID()}`;
        this.handleWindowResize = () => {
            this.requestUpdate();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.handleWindowResize);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.handleWindowResize);
        super.disconnectedCallback();
    }
    handleMediaQuery(event) {
        this.isDesktop = !event.detail.value;
        this.requestUpdate();
    }
    getItemsPerRow() {
        const width = window.innerWidth;
        if (width >= 1440)
            return 2;
        if (width >= 1024)
            return 1;
        if (width >= 768)
            return 2;
        return 1;
    }
    shouldShowDivider(index, totalItems, itemsPerRow) {
        const isEndOfRow = (index + 1) % itemsPerRow === 0;
        const isNotLastRow = index + 1 < totalItems;
        return isEndOfRow && isNotLastRow;
    }
    renderDivider() {
        return $ `<hr class="row-divider" aria-hidden="true">`;
    }
    renderCategoryItem(item, index, hasDivider) {
        return $ `<main-categories-item-updated .item="${item}" .index="${index}" .rtl="${this.rtl}" .hasDivider="${hasDivider}" .idPrefix="${this.componentId}"></main-categories-item-updated>`;
    }
    renderCategoryItems(hasDivider) {
        const itemsPerRow = this.getItemsPerRow();
        const items = [];
        for (let i = 0; i < this.categoryItems.length; i += 1) {
            const item = this.categoryItems[i];
            items.push(this.renderCategoryItem(item, i, hasDivider));
            if (hasDivider &&
                this.shouldShowDivider(i, this.categoryItems.length, itemsPerRow)) {
                items.push(this.renderDivider());
            }
        }
        return items;
    }
    getTitleClasses() {
        const classes = ['section-title'];
        if (!this.showTitle) {
            classes.push('sr-only');
        }
        if (this.showTitle && this.centerTitle) {
            classes.push('centered');
        }
        if (this.showTitle && !this.centerTitle) {
            const isRtl = this.rtl || isRTL();
            classes.push(isRtl ? 'align-right' : 'align-left');
        }
        return classes.join(' ');
    }
    render() {
        if (!this.categoryItems || this.categoryItems.length === 0) {
            return $ `<div class="empty-state" role="status" aria-live="polite">No categories available</div>`;
        }
        const itemCount = this.categoryItems.length;
        const hasDivider = itemCount > 2;
        const wrapperClasses = `main-categories-wrapper ${hasDivider ? 'has-divider' : ''} ${this.utilityClasses || ''}`.trim();
        const containerClasses = `main-categories ${this.rtl || isRTL() ? 'rtl' : ''}`;
        const headingId = `${this.componentId}-heading`;
        const titleClasses = this.getTitleClasses();
        return $ `<section id="${this.componentId}" class="${wrapperClasses}" aria-labelledby="${headingId}"><h2 class="${titleClasses}" id="${headingId}">${o(this.title)}</h2><div class="${containerClasses}">${this.renderCategoryItems(hasDivider)}</div></section><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
MainCategoriesUpdated.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e({ type: Boolean })
], MainCategoriesUpdated.prototype, "rtl", void 0);
__decorate([
    e({ attribute: 'categoryitems', converter: jsonConverter })
], MainCategoriesUpdated.prototype, "categoryItems", void 0);
__decorate([
    e({ type: String, attribute: 'title' })
], MainCategoriesUpdated.prototype, "title", void 0);
__decorate([
    e({ attribute: 'showtitle', converter: booleanConverter })
], MainCategoriesUpdated.prototype, "showTitle", void 0);
__decorate([
    e({ attribute: 'centertitle', converter: booleanConverter })
], MainCategoriesUpdated.prototype, "centerTitle", void 0);
__decorate([
    t()
], MainCategoriesUpdated.prototype, "isDesktop", void 0);
customElements.define('main-categories-updated', MainCategoriesUpdated);

export { MainCategoriesUpdated };
